import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import AppLayout from '../../layouts/app/AppLayout';
import AppIcons from '../../assets/images/icons';
import './custom.scss';

import { translateThis } from '../../helpers/language.helper';
import ApiCaller from '../../services/api/APICaller';
import S3ImageViewerWithFallback from '../../components/awsS3ImageViewer/ImgViewerWithFallback';





const LatestArticles = () => {
    // custom home functions here
    const pageName = "Latest Articles";
    const [dataArr, setDataArr] = useState([]);
    const [latestArticle, setLatestArticle] = useState([]);

    useEffect(() => {
        getDataArr();
    }, [])

    const getDataArr = () => {
        const apiCaller = new ApiCaller('news/latest-news');
        apiCaller.getList().then(({ data }) => {
            setDataArr(data.result)
            setLatestArticle(data.result ? data.result[0] : null)
        })
    }
    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString('en-US', {
            // weekday: 'long', hour: '2-digit', minute: '2-digit',second: '2-digit',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    };
    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper article-page-wrapper f-wrp">
                <div className='article-main-wrp f-wrp'>
                    <div className='article-main-container f-wrp'>
                        <div className='article-main-header f-wrp'>
                            <div className='lft-content'>
                                <h1>{translateThis("Latest")} <b>{translateThis("articles")}</b></h1>
                            </div>
                        </div>

                        <div className='article-main-block f-wrp'>
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className='article-list-wrp f-wrp'>
                                        <Link to={`/individual-articles/${latestArticle?.id}`}
                                            state={{ latestArticle }}>
                                            <div className='new-article-box f-wrp'>
                                                <span className='article-img'><S3ImageViewerWithFallback fileKey={latestArticle.image} /></span>
                                                <div className='article-con-box f-wrp'>
                                                    <span className='new-label'>{translateThis("New")}</span>
                                                    <h5>{latestArticle.title}</h5>
                                                    <p>{latestArticle.subTitle}</p>
                                                </div>
                                            </div>
                                        </Link>
                                        <div className='article-list-box f-wrp'>
                                            <ul>
                                                {dataArr.map((element, key) => (
                                                    <li key={key}>
                                                        <Link to={`/individual-articles/${element?.id}`}
                                                            state={{ element }}
                                                            className='each-article-box'>
                                                            <span className='article-img'><S3ImageViewerWithFallback fileKey={element.image} /></span>
                                                            <div className='article-detail-box'>
                                                                <p><b>{element.title}</b></p>
                                                                <p>{element.subTitle}</p>
                                                                <div className='auth-box f-wrp'>
                                                                    <span className='icon-img'><img src={element.authIcon ? element.authIcon : AppIcons.auther} alt={element.author} /></span>
                                                                    <div className='auth-detail'>
                                                                        <p>{element.author}</p>
                                                                        <span>{formatDate(element.createdAt)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </li>
                                                ))}

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}
LatestArticles.propTypes = {}
export default LatestArticles;